
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState({
        activeCategory: state => state.listings.activeCategory,
        listings: state => state.listings.listings,
      }),
      title() {
        return this.activeCategory?.name
      },
    },
  }
